import type { Field, RichTextContentProtocol, TypeInstanceMap } from '@lighthouse/core'
import { innerTypeToFieldType, NodeFieldPreview, useAtomData } from '@lighthouse/shared'
import React, { useCallback, useMemo } from 'react'

import { lastPageOfStackAtom } from '@/atoms/page/state'
import { useCurrentAppId, useCurrentEnvId } from '@/hooks/useApplication'
import { useDataSourceList } from '@/hooks/useDataSource'
import { useGetPageParameterAndVariableOptions, useGetUserRecordOptions } from '@/hooks/usePage'

interface StateInputProps {
    innerType: TypeInstanceMap
    value: RichTextContentProtocol | undefined
    onChange: (value: RichTextContentProtocol) => void
}

export const StateInput: React.FC<StateInputProps> = ({ innerType: propsInnerType, value, onChange }) => {
    const appId = useCurrentAppId()
    const envId = useCurrentEnvId()
    const dataSourceList = useDataSourceList(appId, envId)
    const pageId = useAtomData(
        lastPageOfStackAtom,
        useCallback(s => s?.pageId || '', [])
    )

    const userOption = useGetUserRecordOptions()
    const pageOptions = useGetPageParameterAndVariableOptions({ pageId, disabledPageState: true })

    const field = useMemo(
        () =>
            ({
                id: '',
                type: innerTypeToFieldType[propsInnerType],
                innerType: propsInnerType
            } as Field),
        [propsInnerType]
    )

    return (
        <NodeFieldPreview
            innerTypes={[propsInnerType]}
            key={propsInnerType}
            field={field}
            style={{ width: 180, fontSize: 14 }}
            autoHeight
            pageOptions={pageOptions}
            userOption={userOption}
            value={value}
            onBlur={onChange}
            dataSourceList={dataSourceList}
        />
    )
}
